import { fetchPrivateLessons } from "@/api/landing";

export default {
  namespaced: true,
  state: {
    privateLessons: {},
    pagination: {
      currentPage: 1,
      total: 0,
      perPage: 10,
      lastPage: 1,
    },
    hasError: false,
  },

  mutations: {
    SET_PRIVATE_LESSONS(state, payload) {
      state.privateLessons = payload;
      state.pagination = {
        currentPage: payload.current_page,
        total: payload.total,
        perPage: payload.per_page,
        lastPage: payload.last_page,
      };
      state.hasError = false;
    },
    SET_ERROR(state, status) {
      state.hasError = status;
    },
  },

  actions: {
    async loadPrivateLessons({ commit }, { page = 1, filters = {} } = {}) {
      try {
        const response = await fetchPrivateLessons({ page, ...filters });
        commit("SET_PRIVATE_LESSONS", response.data);
      } catch (error) {
        commit("SET_ERROR", true);
        console.error("Ошибка загрузки данных:", error);
      }
    },
  },

  getters: {
    getPrivateLessons: (state) => state.privateLessons || [],
    getPagination: (state) => state.pagination || {},
  },
};
